/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Welcome_ElapsedInputs */

const en_welcome_elapsed = /** @type {(inputs: Welcome_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elapsed: ${i?.seconds} s`)
};

const fr_welcome_elapsed = /** @type {(inputs: Welcome_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temps écoulé : ${i?.seconds} s`)
};

const ms_sg2_welcome_elapsed = /** @type {(inputs: Welcome_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berlalu: ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "Elapsed: {seconds} s" |
*
* @param {Welcome_ElapsedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_elapsed = /** @type {((inputs: Welcome_ElapsedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_ElapsedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_elapsed(inputs)
	if (locale === "fr") return fr_welcome_elapsed(inputs)
	return ms_sg2_welcome_elapsed(inputs)
});